// SPDX-License-Identifier: AGPL-3.0-or-later

import Channels from '@app/features/channel/state/Channels';
import GuildMembers from '@app/features/member/state/GuildMembers';
import SelectedGuild from '@app/features/navigation/state/SelectedGuild';
import Relationships from '@app/features/relationship/state/Relationships';
import type {User} from '@app/features/user/models/User';
export function getNickname(user: User, guildId?: string, channelId?: string): string {
	let name = user.displayName;
	const relationship = Relationships.getRelationship(user.id);
	if (relationship?.nickname) {
		name = relationship.nickname;
	}
	guildId ??= SelectedGuild.selectedGuildId ?? undefined;
	if (guildId) {
		const member = GuildMembers.getMember(guildId, user.id);
		if (member?.nick) {
			name = member.nick;
		}
	} else if (channelId) {
		const channel = Channels.getChannel(channelId);
		if (channel?.nicks?.[user.id]) {
			name = channel.nicks[user.id];
		}
	}
	return name;
}
